import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hallo, we are the Lion Brothers.`}</h1>
    <p>{`We provide security services to keep your family safe and build cool websites like this one.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      